module.exports = __webpack_public_path__ + "img/paraqueme.9f344668.png";